export default __webpack_public_path__ + "static/location-coming-soon-big-48cd6a727e79110fe22f0877c93ea6d3.jpg";